import { useTranslation } from '../../../lib/i18n';
import { useBasePath } from '../../../lib/use-base-path';
import { useMe } from '../../../lib/me';

// `tight` is the pane's own verdict on room (the ~370px side dock / a narrow viewport):
// - tight  → the docked hero (Figma 17225:28520): a 24px title that wraps.
// - roomy  → the full hero (Figma 17208:22003): the 32px Archivo title.
export function EmptyLandingHero({ tight }: { tight: boolean }) {
  const { t } = useTranslation();
  const basePath = useBasePath();
  const me = useMe();
  const firstName = (me?.firstName ?? '').trim().split(/\s+/)[0] ?? '';
  const title = firstName
    ? t('chat.emptyState.title', { firstName })
    : t('chat.emptyState.title', { firstName: '' }).replace(/\s{2,}/g, ' ');
  return (
    <div style={{ ...WRAP, padding: tight ? '8px 16px 22px' : '12px 48px 24px' }}>
      <img
        src={`${basePath}/chat-empty-agents.png`}
        alt=""
        aria-hidden
        width={tight ? 180 : 210}
        style={{ width: tight ? 180 : 210, height: 'auto', maxWidth: '100%' }}
      />
      <div style={{ ...TITLE, fontSize: tight ? 24 : 32, lineHeight: tight ? 1.25 : 1.06, marginTop: tight ? 18 : 24 }}>
        {title}
      </div>
      <div style={{ ...SUBTITLE, fontSize: tight ? 15 : 16, marginTop: tight ? 14 : 16 }}>
        {t('chat.emptyState.subtitle')}
      </div>
    </div>
  );
}

const WRAP: React.CSSProperties = {
  width: '100%',
  maxWidth: 760,
  alignSelf: 'center',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 0,
  textAlign: 'center',
};

const TITLE: React.CSSProperties = {
  fontFamily: 'var(--brand-font-display)',
  fontWeight: 'var(--sym-weight-semibold)',
  letterSpacing: '-0.01em',
  color: 'rgba(var(--ink-rgb), 0.92)',
};

const SUBTITLE: React.CSSProperties = {
  color: 'rgba(var(--ink-rgb), 0.6)',
  lineHeight: 1.5,
  maxWidth: 460,
};
